<template>
  <v-row class="mb-4">
    <v-col cols="12">
      <v-skeleton-loader
        v-if="Object.values(loading).some(value => value)"
        type="list-item-three-line"
        height="250"
      ></v-skeleton-loader>
      <v-card v-else-if="randomQuote" elevation="1" class="quote-card">
        <v-card-text class="text-center d-flex align-center justify-center quote-card-text">
          <transition name="fade" mode="out-in">
            <div :key="quoteKey" style="cursor: pointer;" @click="getRandomQuote">
              <div class="font-weight-light quote-text"><em>"{{ randomQuote.quote_text }}"</em></div>
              <div class="font-weight-light quote-author mt-6">— {{ randomQuote.author }}</div>
            </div>
          </transition>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>

  <v-skeleton-loader
    v-if="Object.values(loading).some(value => value)"
    type="list-item-three-line"  
    height="250"
  ></v-skeleton-loader>
  <v-row v-else>
      <v-col cols="12">
        <v-card class="" elevation="1">
          <!-- Total Assets Section -->
          <v-card-title class="d-flex flex-column align-center">
            <div class="font-weight-light info-card-primary-title">all assets</div>
            <div class="font-weight-light info-card-primary-data">{{ Number(balance_sheet.total_asset_value).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</div>
          </v-card-title>
          <v-divider style="width: 25%; margin: 0 auto;" />
          <v-card-text class="text-left">
            <v-container>
              <v-row class="mt-2 mb-2" justify="center">
                <v-col class="text-center asset-col">
                  <router-link to="/securitiessummary" class="asset-link">
                    <div class="font-weight-light info-card-secondary-title">securities</div>
                    <div class="font-weight-light info-card-secondary-data">{{ (balance_sheet.assets.securities + balance_sheet.assets.super_funds).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</div>
                    <div class="font-weight-light info-card-secondary-title">{{ (((balance_sheet.assets.securities + balance_sheet.assets.super_funds) / balance_sheet.total_asset_value) * 100).toLocaleString("en", {minimumFractionDigits: 1, maximumFractionDigits: 1}) }}%</div>
                  </router-link>
                </v-col>
                <v-col class="text-center asset-col">
                  <router-link to="/properties" class="asset-link">
                    <div class="font-weight-light info-card-secondary-title">properties</div>
                    <div class="font-weight-light info-card-secondary-data">{{ Number(balance_sheet.assets.properties).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</div>
                    <div class="font-weight-light info-card-secondary-title">{{ Number((balance_sheet.assets.properties / balance_sheet.total_asset_value) * 100).toLocaleString("en", {minimumFractionDigits: 1, maximumFractionDigits: 1}) }}%</div>
                  </router-link>
                </v-col>
                <v-col class="text-center asset-col">
                  <router-link to="/loans" class="asset-link">
                    <div class="font-weight-light info-card-secondary-title">loans</div>
                    <div class="font-weight-light info-card-secondary-data">{{ Number(balance_sheet.assets.loans).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</div>
                    <div class="font-weight-light info-card-secondary-title">{{ Number((balance_sheet.assets.loans / balance_sheet.total_asset_value) * 100).toLocaleString("en", {minimumFractionDigits: 1, maximumFractionDigits: 1}) }}%</div>
                  </router-link>
                </v-col>
                <v-col class="text-center asset-col">
                  <router-link to="/cash" class="asset-link">
                    <div class="font-weight-light info-card-secondary-title">cash</div>
                    <div class="font-weight-light info-card-secondary-data">{{ Number(balance_sheet.assets.cash).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</div>
                    <div class="font-weight-light info-card-secondary-title">{{ Number((balance_sheet.assets.cash / balance_sheet.total_asset_value) * 100).toLocaleString("en", {minimumFractionDigits: 1, maximumFractionDigits: 1}) }}%</div>
                  </router-link>
                </v-col>
                <v-col class="text-center asset-col">
                  <router-link to="/collectibles" class="asset-link">
                    <div class="font-weight-light info-card-secondary-title">collectibles</div>
                    <div class="font-weight-light info-card-secondary-data">{{ Number(balance_sheet.assets.collectibles).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</div>
                    <div class="font-weight-light info-card-secondary-title">{{ Number((balance_sheet.assets.collectibles / balance_sheet.total_asset_value) * 100).toLocaleString("en", {minimumFractionDigits: 1, maximumFractionDigits: 1}) }}%</div>
                  </router-link>
                </v-col>
                <v-col class="text-center asset-col">
                  <router-link to="/vehicles" class="asset-link">
                    <div class="font-weight-light info-card-secondary-title">vehicles</div>
                    <div class="font-weight-light info-card-secondary-data">{{ Number(balance_sheet.assets.vehicles).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</div>
                    <div class="font-weight-light info-card-secondary-title">{{ Number((balance_sheet.assets.vehicles / balance_sheet.total_asset_value) * 100).toLocaleString("en", {minimumFractionDigits: 1, maximumFractionDigits: 1}) }}%</div>
                  </router-link>
                </v-col>
                <v-col class="text-center asset-col">
                  <router-link to="/otherassets" class="asset-link">
                    <div class="font-weight-light info-card-secondary-title">other</div>
                    <div class="font-weight-light info-card-secondary-data">{{ Number(balance_sheet.assets.other_assets).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</div>
                    <div class="font-weight-light info-card-secondary-title">{{ Number((balance_sheet.assets.other_assets / balance_sheet.total_asset_value) * 100).toLocaleString("en", {minimumFractionDigits: 1, maximumFractionDigits: 1}) }}%</div>
                  </router-link>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
  </v-row>

  <v-row class="full-height-row">
    <v-col cols="12" md="6">
      <v-skeleton-loader 
        v-if="Object.values(loading).some(value => value)"
        type="list-item-three-line"  
        height="250"
      ></v-skeleton-loader>
      <v-card v-else class="full-height-card">
          <v-card-title class="d-flex flex-column align-center">
            <div class="font-weight-light info-card-primary-title">active portfolio</div>
            <div class="font-weight-light info-card-primary-data">{{ Number(security_allocation_data.portfolio_value).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</div>
          </v-card-title>
          <v-divider style="width: 50%; margin: 0 auto;" />
          <v-card-text  class="text-left">
            <v-container> 
              <v-row v-for="broad in security_allocation_data.broad_categories" :key="broad.id">
                <v-col cols="6" class="pa-0 indent-5 font-weight-light sub-heading-text">{{ broad.name }}</v-col>
                <v-col cols="3" class="pa-0 text-right font-weight-light sub-heading-text">{{ Number(broad.value).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0})}}</v-col>
                <v-col cols="3" class="pa-0 text-right font-weight-light sub-heading-text">{{ Number((broad.pct_portfolio)*100).toLocaleString("en", {minimumFractionDigits: 1, maximumFractionDigits: 1})}}%</v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pa-0 indent-5 font-weight-light sub-heading-text">super funds</v-col>
                <v-col cols="3" class="pa-0 text-right font-weight-light sub-heading-text">{{ Number(security_allocation_data.super_funds_value).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0})}}</v-col>
                <v-col cols="3" class="pa-0 text-right font-weight-light sub-heading-text">{{ Number(security_allocation_data.super_funds_pct_portfolio * 100).toLocaleString("en", {minimumFractionDigits: 1, maximumFractionDigits: 1})  }}%</v-col>
              </v-row>
              <v-row>
                <v-col cols="6" class="pa-0 indent-5 font-weight-light sub-heading-text">cash & loans</v-col>
                <v-col cols="3" class="pa-0 text-right font-weight-light sub-heading-text">{{ Number(security_allocation_data.cash_value).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0})}}</v-col>
                <v-col cols="3" class="pa-0 text-right font-weight-light sub-heading-text">{{ Number(security_allocation_data.cash_pct_portfolio * 100).toLocaleString("en", {minimumFractionDigits: 1, maximumFractionDigits: 1})  }}%</v-col>
              </v-row>
            </v-container>
          </v-card-text>
      </v-card>
    </v-col>

    <v-col cols="12" md="6">
      <v-skeleton-loader
        v-if="Object.values(loading).some(value => value)"
        type="list-item-three-line"
        height="503"
      ></v-skeleton-loader>
      <v-card v-else class="full-height-card centered-content-card">
        <v-card-title class="d-flex flex-column align-center">
          <div class="font-weight-light info-card-primary-title">forecast annual expenditure</div>
          <div class="font-weight-light info-card-primary-data">{{  Number(pl_data.total_expenses).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</div>
          <v-divider style="width: 50%; margin: 0 auto;" class="mt-2" />
          <div class="font-weight-light info-card-secondary-title mt-2">withdrawal rate: {{ withdrawalRate }}%</div>
        </v-card-title>
      </v-card>
    </v-col>
</v-row>
  <!--   
  <v-row>
    <v-col cols="6" md="6">
      
      <v-card>
        <v-card-item>
          <v-card-title class="text-left font-weight-light card-title-text">financial position</v-card-title>
        </v-card-item>
        <v-divider></v-divider>
          <v-skeleton-loader 
            v-if="loading.financial_position && loading.asset_allocation && loading.financial_performance && loading.future_value"
            type="list-item-three-line"  
            height="250"
          ></v-skeleton-loader>
          <v-card-text v-else class="text-left">
            <v-container> 
              <v-row>
                <v-col cols="8" md="8" class="pa-0 sub-heading-text">assets</v-col>
              </v-row>
              <v-row>
                <v-col cols="8" md="8" class="pa-0 indent-5 font-weight-light content-text">properties</v-col>
                <v-col cols="4" md="4" class="pa-0 text-right font-weight-light content-text">{{ Number(balance_sheet.assets.properties).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</v-col>
              </v-row>
              <v-row>
                <v-col cols="8" md="8" class="pa-0 indent-5 font-weight-light content-text">vehicles</v-col>
                <v-col cols="4" md="4" class="pa-0 text-right font-weight-light content-text">{{ Number(balance_sheet.assets.vehicles).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</v-col>
              </v-row>
              <v-row>
                <v-col cols="8" md="8" class="pa-0 indent-5 font-weight-light content-text">cash</v-col>
                <v-col cols="4" md="4" class="pa-0 text-right font-weight-light content-text">{{ Number(balance_sheet.assets.cash).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</v-col>
              </v-row>
              <v-row>
                <v-col cols="8" md="8" class="pa-0 indent-5 font-weight-light content-text">loans</v-col>
                <v-col cols="4" md="4" class="pa-0 text-right font-weight-light content-text">{{ Number(balance_sheet.assets.loans).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</v-col>
              </v-row>
              <v-row>
                <v-col cols="8" md="8" class="pa-0 indent-5 font-weight-light content-text">securities</v-col>
                <v-col cols="4" md="4" class="pa-0 text-right font-weight-light content-text">{{ Number(balance_sheet.assets.securities).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</v-col>
              </v-row>
              <v-row>
                <v-col cols="8" md="8" class="pa-0 indent-5 font-weight-light content-text">super funds</v-col>
                <v-col cols="4" md="4" class="pa-0 text-right font-weight-light content-text">{{ Number(balance_sheet.assets.super_funds).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</v-col>
              </v-row>
              <v-row>
                <v-col cols="8" md="8" class="pa-0"></v-col>
                <v-col cols="4" md="4" class="pa-0 text-right sub-heading-text">{{ Number(balance_sheet.total_asset_value).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</v-col>
              </v-row>
              <v-row class="padding-top-10">
                <v-col cols="8" md="8" class="pa-0 sub-heading-text">liabilities</v-col>
                <v-col cols="4" md="4" class="pa-0 text-right sub-heading-text">{{ Number(balance_sheet.total_liability_value).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</v-col>
              </v-row>
              <v-row class="padding-top-10">
                <v-col cols="8" md="8" class="pa-0 sub-heading-text">equity</v-col>
                <v-col cols="4" md="4" class="pa-0 text-right sub-heading-text text-decoration-overline">{{ Number(balance_sheet.total_equity_value).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</v-col>
              </v-row>
            </v-container>
          </v-card-text>
      </v-card>
      --> 
    
      <!--
      <v-card class="mt-5">
        <v-card-item>
          <v-card-title class="text-left font-weight-light card-title-text">asset allocation</v-card-title>
        </v-card-item>
        <v-divider></v-divider>
        <v-skeleton-loader 
          v-if="loading.financial_position && loading.asset_allocation && loading.financial_performance && loading.future_value"
          type="list-item-three-line"  
          class="mt-5"
          height="620"
        ></v-skeleton-loader>
        <v-card-text v-else class="text-left">
          <v-container>
            <AssetAllocationPieChart v-if="gotAssetAllocationData" :chartData="this.asset_allocation_chart_data"/>
          </v-container>
        </v-card-text>
      </v-card>
      -->

    
    <!--
    <v-col cols="6" md="6">
      <v-card>
        <v-card-item>
          <v-card-title class="text-left font-weight-light card-title-text">forecast financial performance</v-card-title>
        </v-card-item>
        <v-divider></v-divider>
        <v-skeleton-loader 
          v-if="loading.financial_position && loading.asset_allocation && loading.financial_performance && loading.future_value"
          type="list-item-three-line"  
          height="503"
        ></v-skeleton-loader>
        <v-card-text v-else class="text-left">
          <v-container>
            <v-row>
              <v-col cols="8" md="8" class="pa-0 sub-heading-text">revenue</v-col>
            </v-row>
            <v-row v-for="revenue_item in pl_data.revenue" :key="revenue_item">
              <v-col cols="8" md="8" class="pa-0 indent-5 font-weight-light content-text">{{ revenue_item.identifier }}</v-col>
              <v-col cols="4" md="4" class="pa-0 text-right font-weight-light content-text">{{ Number(revenue_item.amount).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="8" md="8" class="pa-0"></v-col>
              <v-col cols="4" md="4" class="pa-0 text-right sub-heading-text">{{ Number(pl_data.total_revenue).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</v-col>
            </v-row>
            <v-row class="padding-top-10">
              <v-col cols="8" md="8" class="pa-0 sub-heading-text">tax({{ Number(pl_data.assumed_tax_rate).toLocaleString(undefined,{style: 'percent', minimumFractionDigits:0}) }})</v-col>
              <v-col cols="4" md="4" class="pa-0 text-right sub-heading-text">{{ Number(pl_data.tax_payable).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</v-col>
            </v-row>
            <v-row class="padding-top-10">
              <v-col cols="8" md="8" class="pa-0 sub-heading-text">expenses</v-col>
            </v-row>
            <v-row v-for="expense_item in pl_data.expenses" :key="expense_item">
              <v-col cols="8" md="8" class="pa-0 indent-5 font-weight-light content-text">{{ expense_item.identifier }}</v-col>
              <v-col cols="4" md="4" class="pa-0 text-right font-weight-light content-text">{{ Number(expense_item.annual_budget).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="8" md="8" class="pa-0"></v-col>
              <v-col cols="4" md="4" class="pa-0 text-right sub-heading-text">{{ Number(pl_data.total_expenses).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</v-col>
            </v-row>
            <v-row class="padding-top-10">
              <v-col cols="8" md="8" class="pa-0 sub-heading-text">profit</v-col>
              <v-col cols="4" md="4" class="pa-0 text-right sub-heading-text text-decoration-overline">{{ Number(pl_data.profit).toLocaleString("en", {minimumFractionDigits: 0, maximumFractionDigits: 0}) }}</v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-col>
    -->



  

</template>

<script>
import axios from 'axios';
import { mapState, mapMutations} from 'vuex';
import AssetAllocationPieChart from './charts/DoughnutChart.vue';

export default {
  components: {
    AssetAllocationPieChart,
  },
  data() {
    return {
      balance_sheet: {},
      pl_data: {},
      asset_allocation_data: {},
      security_allocation_data: {},
      asset_allocation_chart_data: {
        labels: [],
        datasets: [
          {
            backgroundColor: ['#4dc9f6','#f67019','#f53794','#537bc4','#acc236','#166a8f','#00a950','#58595b','#8549ba'],
            data: []
          }
        ]
      },
      randomQuote: null,
      quoteKey: 0,
      quoteInterval: null,
      gotAssetAllocationData: false,
      loading: {
        financial_position: true,
        financial_performance: true,
        asset_allocation: true,
        security_allocation: true,
      },
    };
  },
  async created() {
    this.getRandomQuote();
    this.quoteInterval = setInterval(() => this.getRandomQuote(), 5 * 60 * 1000);
    await Promise.allSettled([
      this.getBalanceSheetData(),
      this.getPandLData(),
      this.getAssetAllocationData(),
      this.getSecurityAllocationData(),
    ]);
  },
  beforeUnmount() {
    if (this.quoteInterval) {
      clearInterval(this.quoteInterval);
    }
  },
  computed: {
    ...mapState({
      token: "token"
    }),
    withdrawalRate() {
      const expenses = this.pl_data?.total_expenses;
      const assets = this.balance_sheet?.spendable_asset_value;
      if (!expenses || !assets) return '0.0';
      return ((expenses / assets) * 100).toLocaleString("en", {minimumFractionDigits: 1, maximumFractionDigits: 1});
    },
  },
  methods: {
      ...mapMutations(["showSnackbar"]),
    async getRandomQuote() {
      try {
        const response = await axios.get("/quotes/random", {
          headers: { Authorization: `Bearer ${this.token}` }
        });
        if (response.data) {
          this.randomQuote = response.data;
          this.quoteKey++;
        }
      } catch (error) {
        // silently fail — quote card will just not show
      }
    },
    async getBalanceSheetData(){
      try {
        const response = await axios.get("/reports/balancesheet", {
          headers: { Authorization: `Bearer ${this.token}` }
        });
        this.balance_sheet = response.data;
        this.loading.financial_position = false;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load balance sheet' });
      }
    },
    async getPandLData(){
      try {
        const response = await axios.get("/reports/p&l", {
          headers: { Authorization: `Bearer ${this.token}` }
        });
        this.pl_data = response.data;
        this.loading.financial_performance = false;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load profit and loss data' });
      }
    },
    async getAssetAllocationData(){
      try {
        const response = await axios.get("/reports/assetallocation", {
          headers: { Authorization: `Bearer ${this.token}` }
        });
        this.asset_allocation_data = response.data;
        this.loading.asset_allocation = false;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load asset allocation' });
      }
    },
    async getSecurityAllocationData(){
      try {
        const response = await axios.get("/reports/securityallocation", {
          headers: { Authorization: `Bearer ${this.token}` }
        });
        const data = response.data;
        // Derive portfolio total from displayed parts so values always add up
        const broadTotal = data.broad_categories.reduce((sum, b) => sum + b.value, 0);
        const superFundsValue = data.super_funds_value || 0;
        data.portfolio_value = broadTotal + superFundsValue + data.cash_value;
        // Recalculate percentages against derived total
        for (const broad of data.broad_categories) {
          broad.pct_portfolio = data.portfolio_value !== 0 ? broad.value / data.portfolio_value : 0;
        }
        data.super_funds_pct_portfolio = data.portfolio_value !== 0 ? superFundsValue / data.portfolio_value : 0;
        data.cash_pct_portfolio = data.portfolio_value !== 0 ? data.cash_value / data.portfolio_value : 0;
        this.security_allocation_data = data;
        this.loading.security_allocation = false;
      } catch (error) {
        this.showSnackbar({ message: 'Failed to load security allocation' });
      }
    },
    createAssetAllocationChartDataRequest(){
      this.asset_allocation_data.assets.forEach(element => {
        this.asset_allocation_chart_data.labels.push(element.identifier);
        this.asset_allocation_chart_data.datasets[0].data.push((element.allocation) * 100);
      });

      this.gotAssetAllocationData = true;
    },

  }
};


</script>


<style scoped>

.indent-5{
  padding-left: 5px !important;
}

.card-title-text{
  font-size: 2.125rem;
}

.sub-heading-text{
  font-size: 1.5rem;
}

.content-text{
  font-size: 1.2rem;
}

.padding-top-10{
  padding-top: 10px;
}

.info-card-primary-data{
  font-size: 2.5rem;
}

.info-card-primary-title{
  font-size: 1.75rem;
}

.info-card-secondary-data{
  font-size: 1.3rem;
}

.info-card-secondary-title{
  font-size: 1.25rem;
}

.asset-link{
  text-decoration: none;
  color: inherit;
}

.asset-col{
  flex: 1 1 0;
  max-width: 14.28%;
}

.full-height-row {
  display: flex;
  align-items: stretch; /* Makes all v-col children stretch to the same height */
}

.full-height-card {
  height: 100%; /* Makes the v-card fill the height of its parent v-col */
}

.centered-content-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.centered-content-card .v-card-title {
  padding: 16px; /* Adjust padding if needed */
}

.text-center{
  text-align: center;
}

.quote-card {
  height: 300px;
}

.quote-card-text {
  padding: 96px;
  height: 300px;
  overflow: hidden;
}

.quote-text{
  font-size: 1.5rem;
}

.quote-author{
  font-size: 1rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}



</style>